import { DEFAULTSELECTEDLANGUAGE, SUPPORTEDLANGUAGES } from "app/utils/const";
import isPublicView from "app/utils/publicViewUtils";
import cookie from "react-cookies";

/** A collection of language selection related helper functions */
export class LanguageSelectionHelper {
  /**
   * Get the language from the cookie
   * If not set, or incorrectly set, return default
   * @param {string} languageSelectionHelper
   */
  static checkSelectedLanguage(): string {
    let lang = LanguageSelectionHelper.checkCookieLanguageSelected();

    const isSupportedLocale = SUPPORTEDLANGUAGES.some(
      language => language.locale === lang
    );

    if (!lang || !isSupportedLocale) {
      if (isPublicView()) {
        if (lang === undefined) {
          LanguageSelectionHelper.saveLanguageToCookie(DEFAULTSELECTEDLANGUAGE);
        } else {
          LanguageSelectionHelper.saveLanguageToCookie(
            isPublicView() ? lang : DEFAULTSELECTEDLANGUAGE
          );
        }
      } else
        LanguageSelectionHelper.saveLanguageToCookie(DEFAULTSELECTEDLANGUAGE);

      return DEFAULTSELECTEDLANGUAGE;
    }
    return lang;
  }
  /**
   * Save accept cookies terms in a cookie.
   * @param {string} languageSelectionHelper
   */
  static checkSelectedLanguageBetRadarWidget(): string {
    // check cookie to language selection
    let lang = LanguageSelectionHelper.checkCookieLanguageSelected();
    // if no language selected in cookie return default language of english
    return lang ? lang.substring(0, 2) : "en";
  }

  /**
   * Save language
   * @param {string} languageSelectionHelper
   */
  static saveLanguageToCookie(lang: string) {
    cookie.save("language", lang, {
      path: "/",
    });
  }

  static saveLanguageChangedToCookie(changed: boolean) {
    cookie.save("languageChanged", changed ? "true" : "false", {
      path: "/",
    });
  }

  static getLanguageChangedFromCookie(): boolean {
    const value = cookie.load("languageChanged");
    return value === "true" ? true : false;
  }

  static clearLanguageChanged() {
    cookie.remove("languageChanged", {
      path: "/",
    });
  }

  /**
   * Save delete accept cookie terms in a cookie.
   * @param {string} languageSelectionHelper
   */
  static deleteLanguageSelectedFromCookie() {
    cookie.remove("language", {
      path: "/",
    });
  }

  /**
   * Save delete accept cookie terms in a cookie.
   * @param {string} languageSelectionHelper
   */
  static checkCookieLanguageSelected(): string {
    const value = cookie.load("language");
    return value && (value as string);
  }
}
